class InfiniteScroll extends HTMLElement {
  constructor() {
    super()
    this.loading = false
    this.page = 1
    this.maxPages = parseInt(this.dataset.maxPages || 1)
    this.container = this.querySelector('.space-y-8')
    this.trigger = this.querySelector('.infinite-scroll-trigger')
    this.searchQuery = this.dataset.searchQuery || ''
    this.orderBy = this.dataset.orderBy || 'date'
  }

  connectedCallback() {
    this.initButton()
  }

  initButton() {
    if (this.trigger) {
      this.trigger.addEventListener('click', () => {
        if (!this.loading && this.page < this.maxPages) {
          this.loadMore()
        }
      })
    }
  }

  async loadMore() {
    if (this.loading) return

    this.loading = true
    this.page++

    try {
      const response = await fetch(
        `${window.location.origin}/wp-json/basisresearch/v1/search?page=${this.page}&s=${encodeURIComponent(this.searchQuery)}&orderby=${this.orderBy}`
      )

      if (!response.ok) throw new Error('Network response was not ok')

      const data = await response.json()

      if (data.html) {
        this.container.insertAdjacentHTML('beforeend', data.html)
      }

      if (this.page >= this.maxPages) {
        this.trigger.style.display = 'none'
      }
    } catch (error) {
      console.error('Error loading more posts:', error)
    } finally {
      this.loading = false
    }
  }
}

if (!customElements.get('infinite-scroll')) {
  customElements.define('infinite-scroll', InfiniteScroll)
}
